<template>
    <transition name="fade">
        <div v-show="modalVisible">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3 class="modal-title" style="margin-left: auto; margin-right: auto;">
                                    {{ __('connect_with') }}
                                    <button-open-help-modal :inExtraDiv="false" v-bind:helpName="helpName" :color="'dark'"/>
                                </h3>
                                <button class="close" style="margin-left: 0; margin-right: 0;" type="button"
                                        @click="hideModal"><span aria-hidden="true">&times;</span><span
                                    class="sr-only">Close</span></button>
                            </div>

                            <div class="modal-body">
                                <div class="col-md-12"><h4>{{ __('positions_settled') }}</h4></div>

                                <div v-if="modalData.payments_settled.length >= 1" class="col-md-9">
                                    <div class="table-responsive text-nowrap">
                                        <table class="table table-striped payments-settled">
                                            <thead>
                                            <tr>
                                                <th class="th-first-modal width-fix">{{ __('date') }}</th>
                                                <th class="width-fix">{{ __('payment_source') }}</th>
                                                <th class="text-right width-fix">{{ __('amount') }}</th>
                                                <th class="text-right width-fix">{{ __('for_allocation') }}</th>
                                                <th class="text-right balance"></th>
                                                <th class="currency">{{ __('currency') }}</th>
                                                <th class="text-right width-fix th-last">{{ __('has_left') }}</th>
                                            </tr>
                                            </thead>
                                            <tbody v-for="operation in modalData.payments_settled">
                                            <tr class="row-one-line indexable">
                                                <td class="td-padding" data-cy="connect-with-operation-date">{{ operation.date }}</td>
                                                <td class="td-padding wrap-text-inside-td" data-cy="connect-with-operation-payment-source" style="white-space: break-spaces">{{ operation.payment_source }}</td>
                                                <td class="td-padding text-right" data-cy="connect-with-operation-amount">
                                                    {{ operation.operation_amount | localizeMoney }}
                                                </td>
                                                <td class="td-padding text-right" data-cy="connect-with-operation-target-amount">
                                                    {{ operation.target_amount | localizeMoney }}
                                                </td>
                                                <td class="td-padding"></td>
                                                <td class="td-padding" data-cy="connect-with-operation-currency">{{ operation.currency }}</td>
                                                <td class="td-padding text-right" data-cy="connect-with-operation-has-left">
                                                    <input :value="operation.has_left" class="form-control text-right" data-cy="connect-with-operation-has-left-input" readonly
                                                           type="text">
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div v-if="modalData.documents_settled.length >= 1" class="col-md-9">
                                    <div class="table-responsive text-nowrap">
                                        <table class="table table-striped documents-settled">
                                            <thead>
                                            <tr>
                                                <th class="th-first-modal width-fix">{{ __('document_marking') }}</th>
                                                <th class="width-fix">{{ __('date_issued') }}</th>
                                                <th class="text-right width-fix">{{ __('amount') }}</th>
                                                <th class="text-right width-fix">{{ __('document_balance') }}</th>
                                                <th class="text-right balance"></th>
                                                <th class="currency">{{ __('currency') }}</th>
                                                <th class="text-right width-fix th-last">{{ __('has_left') }}</th>
                                            </tr>
                                            </thead>

                                            <tbody v-for="document in modalData.documents_settled">
                                            <tr class="row-one-line indexable">
                                                <td class="td-padding" data-cy="connect-with-document-date"><truncated-text :text="document.document_number" :max_length="20"/>
                                                </td>
                                                <td class="td-padding" data-cy="connect-with-document-date-issued">{{ document.date_issued }}</td>
                                                <td class="td-padding text-right " data-cy="connect-with-document-gross-amount">
                                                    {{ document.document_gross_amount | localizeMoney }}
                                                </td>
                                                <td class="td-padding text-right " data-cy="connect-with-document-balance">
                                                    {{ document.document_balance |  localizeMoney }}
                                                </td>
                                                <td class="td-padding"></td>
                                                <td class="td-padding" data-cy="connect-with-document-currency">{{ document.currency | toUpper }}</td>
                                                <td>
                                                    <input :value="document.has_left" class="form-control text-right" data-cy="connect-with-document-has-left-input" readonly
                                                           type="text">
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="col-md-12"><h4>{{ __('connect_with') }}</h4></div>

                                <div v-if="modalData.unallocated_payments.length >= 1" class="col-md-12">
                                    <div class="table-responsive text-nowrap">
                                        <h5>{{ __('unallocated_payments') }}</h5>
                                        <table class="table table-striped unallocated-payments">
                                            <thead>
                                            <tr>
                                                <th class="th-first-modal width-fix date">{{ __('date') }}</th>
                                                <th class="width-fix">{{ __('payment_source') }}</th>
                                                <th class="text-right width-fix">{{ __('amount') }}</th>
                                                <th class="text-right width-fix">{{ __('for_allocation') }}</th>
                                                <th class="text-right balance">{{ __('balance_after_settlement') }}</th>
                                                <th class="currency">{{ __('currency') }}</th>
                                                <th class="text-right width-fix">{{ __('allocated') }}</th>
                                                <th class="text-right width-fix">{{ __('exchange_rate') }}</th>
                                                <th class="text-right width-fix">{{ __('calculated_amount') }}</th>
                                                <th class="th-before th-last currency">{{ __('currency') }}</th>

                                            </tr>
                                            </thead>
                                            <tbody v-for="(operation, index) in modalData.unallocated_payments">
                                            <tr class="row-one-line indexable">
                                                <td class="td-padding" data-cy="connect-with-operation-date" >{{ operation.date }}</td>
                                                <td class="td-padding wrap-text-inside-td" data-cy="connect-with-operation-payment-source" style="white-space: break-spaces">{{ operation.payment_source }}</td>
                                                <td class="td-padding text-right" data-cy="connect-with-operation-amount">
                                                    {{ operation.operation_amount | localizeMoney }}
                                                </td>
                                                <td class="td-padding text-right" data-cy="connect-with-operation-target-amount">
                                                    {{ operation.target_amount | localizeMoney }}
                                                </td>
                                                <td class="td-padding">
                                                    <input :value="operation.has_left" class="form-control text-right" data-cy="connect-with-operation-has-left"
                                                           placeholder="0,00" readonly
                                                           type="text">
                                                </td>
                                                <td class="td-padding currency" data-cy="connect-with-o[eration-allocation-currency">
                                                    {{ operation.allocation.currency | toUpper }}
                                                </td>
                                                <td class="td-padding text-right">
                                                    <div
                                                        :class="{ 'has-error': hasError('unallocated.operations.' +  index + '.exchanged_amount') }">
                                                        <input v-model="operation.allocation.amount"
                                                               :readonly="readonlyAmount(operation)"
                                                               class="exchanged-amount form-control text-right"
                                                               data-cy="connect-with-operation-allocation-amount"
                                                               placeholder="0,00"
                                                               type="text"
                                                               @change="handleAmountChange('operation', index)"
                                                               @keydown="preventNonNumbers($event)">
                                                    </div>
                                                </td>
                                                <td class="exchange-rate-lg">
                                                    <input v-show="showExchangeRate(operation)"
                                                           v-model="operation.allocation.exchange_rate"
                                                           :readonly="readonlyExchangeRate(operation)"
                                                           class="exchange-rate form-control text-right exchange-rate-lg"
                                                           data-cy="connect-with-operation-allocation-exchange-rate"
                                                           placeholder="0,0000"
                                                           type="text"
                                                           @change="handleExchangeRateChange('operation', index)"
                                                           @keydown="preventNonNumbers($event)">
                                                </td>
                                                <td>
                                                    <div
                                                        :class="{ 'has-error': hasError('unallocated.operations.' +  index + '.exchanged_amount') }">
                                                        <input v-show="showExchangedAmount(operation)" v-model="operation.allocation.exchanged_amount"
                                                               :readonly="readonlyExchangedAmount(operation)"
                                                               class="amount form-control text-right"
                                                               data-cy="connect-with-operation-allocation-exchange-amount"
                                                               placeholder="0,00"
                                                               type="text"
                                                               @change="handleExchangedAmountChange('operation', index)"
                                                               @keydown="preventNonNumbers($event)">
                                                    </div>
                                                </td>
                                                <td>
                                                    <input v-show="showExchangedAmount(operation)" v-model="operation.allocation.currency" data-cy="connect-with-operation-allocation-currency-input" class="currency form-control"
                                                           readonly
                                                           type="text">
                                                </td>
                                            </tr>
                                            <tr v-show="rowHasError(index, 'operations')" class="tr-errors">
                                                <td colspan="6"></td>
                                                <td>
                                <span v-show="hasError('unallocated.operations.' +  index + '.exchanged_amount')"
                                      class="help-block text-danger">
                                    {{
                                        hasError('unallocated.operations.' + index + '.amount') ? modalData.errors['unallocated.operations.' + index + '.amount'][0] : ''
                                    }}
                                </span>
                                                </td>
                                                <td></td>
                                                <td>
                               <span
                                   v-show="hasError('unallocated.operations.' +  index + '.amount') && showExchangedAmount(operation)"
                                   class="help-block text-danger">
                                    {{
                                       hasError('unallocated.operations.' + index + '.amount') ? modalData.errors['unallocated.operations.' + index + '.amount'][0] : ''
                                   }}
                                </span>
                                                </td>
                                                <td></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div v-if="modalData.unallocated_documents.length >= 1" class="col-md-12">
                                    <div class="table-responsive text-nowrap">
                                        <h5 v-show="!settlementOperationToDocument()">{{
                                                __('unallocated_documents')
                                            }}</h5>
                                        <table class="table table-striped unallocated-documents">
                                            <thead>
                                            <tr>
                                                <th class="th-first-modal width-fix">{{ __('document_marking') }}</th>
                                                <th class="width-fix">{{ __('date_issued') }}</th>
                                                <th class="text-right width-fix">{{ __('amount') }}</th>
                                                <th class="text-right width-fix">{{ __('document_balance') }}</th>
                                                <th class="text-right balance">{{ __('balance_after_allocation') }}</th>
                                                <th class="currency">{{ __('currency') }}</th>
                                                <th class="text-right width-fix">{{ __('allocated') }}</th>
                                                <th class="text-right width-fix">{{ __('exchange_rate') }}</th>
                                                <th class="text-right width-fix">{{ __('calculated_amount') }}</th>
                                                <th class="th-before th-last currency">{{ __('currency') }}</th>
                                            </tr>
                                            </thead>
                                            <tbody v-for="(document, index) in modalData.unallocated_documents">
                                            <tr class="row-one-line indexable">
                                                <td class="td-padding" data-cy="connect-with-document-number" ><truncated-text :text="document.document_number" :max_length="20"/>
                                                </td>
                                                <td class="td-padding" data-cy="connect-with-document-date-issued">{{ document.date_issued }}</td>
                                                <td class="td-padding text-right" data-cy="connect-with-document-gross-amount">
                                                    {{ document.document_gross_amount | localizeMoney }}
                                                </td>
                                                <td class="td-padding text-right" data-cy="connect-with-document-balance">
                                                    {{ document.document_balance | localizeMoney }}
                                                </td>
                                                <td>
                                                    <input :value="document.has_left" class="form-control text-right"  data-cy="connect-with-document-has-left"
                                                           placeholder="0,00" readonly
                                                           type="text">
                                                </td>
                                                <td class="td-padding currency" data-cy="connect-with-document-allocation-currency">
                                                    {{ document.allocation.currency | toUpper }}
                                                </td>
                                                <td>
                                                    <div
                                                        :class="{ 'has-error': hasError('unallocated.unallocated_documents.' +  index + '.exchanged_amount') }">
                                                        <input v-model="document.allocation.amount"
                                                               :readonly="readonlyAmount(document)"
                                                               class="exchanged-amount form-control text-right"
                                                               data-cy="connect-with-document-allocation-amount"
                                                               placeholder="012,00"
                                                               type="text"
                                                               @change="handleAmountChange('unallocated_document', index)"
                                                               @keydown="preventNonNumbers($event)">
                                                    </div>
                                                </td>
                                                <td class="exchange-rate-lg">
                                                    <input v-show="showExchangeRate(document)"
                                                           v-model="document.allocation.exchange_rate"
                                                           :readonly="readonlyExchangeRate(document)"
                                                           class="exchange-rate form-control text-right exchange-rate-lg"
                                                           data-cy="connect-with-document-allocation-exchange-rate"
                                                           placeholder="0,0000"
                                                           type="text"
                                                           @change="handleExchangeRateChange('unallocated_document', index)"
                                                           @keydown="preventNonNumbers($event)">
                                                </td>
                                                <td>
                                                    <div
                                                        :class="{ 'has-error': hasError('unallocated.unallocated_documents.' +  index + '.amount') }">
                                                        <input v-show="showExchangedAmount(document)" v-model="document.allocation.exchanged_amount"
                                                               :readonly="readonlyExchangedAmount(document)"
                                                               class="amount form-control text-right"
                                                               data-cy="connect-with-document-allocation-exchanged-amount"
                                                               placeholder="0,00"
                                                               type="text"
                                                               @change="handleExchangedAmountChange('unallocated_document', index)"
                                                               @keydown="preventNonNumbers($event)">
                                                    </div>
                                                </td>
                                                <td class="td-padding" colspan="4">
                                                    <input v-show="showExchangedAmount(document)" v-model="document.allocation.currency" data-cy="connect-with-document-allocation-currency-input" class="currency form-control"
                                                           readonly
                                                           type="text"
                                                           value="PLN">
                                                </td>
                                            </tr>
                                            <tr v-show="rowHasError(index, 'unallocated_documents')" class="tr-errors">
                                                <td colspan="6"></td>
                                                <td>
                            <span v-show="hasError('unallocated.unallocated_documents.' +  index + '.exchanged_amount')"
                                  class="help-block text-danger">
                                {{
                                    hasError('unallocated.unallocated_documents.' + index + '.amount') ? modalData.errors['unallocated.unallocated_documents.' + index + '.amount'][0] : ''
                                }}
                            </span>
                                                </td>
                                                <td></td>
                                                <td>
                           <span
                               v-show="hasError('unallocated.unallocated_documents.' +  index + '.amount') && showExchangedAmount(document)"
                               class="help-block text-danger">
                                {{
                                   hasError('unallocated.unallocated_documents.' + index + '.amount') ? modalData.errors['unallocated.unallocated_documents.' + index + '.amount'][0] : ''
                               }}
                           </span>
                                                </td>
                                                <td></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div v-if="modalData.documents.length >= 1" class="col-md-12">
                                    <div class="table-responsive text-nowrap">
                                        <h5 v-show="!settlementOperationToDocument()">{{ __('documents') }}</h5>
                                        <table class="table table-striped unallocated-documents">
                                            <thead>
                                            <tr>
                                                <th class="th-first-modal width-fix">{{ __('document_marking') }}</th>
                                                <th class="width-fix">{{ __('date_issued') }}</th>
                                                <th class="text-right width-fix">{{ __('amount') }}</th>
                                                <th class="text-right width-fix">{{ __('document_balance') }}</th>
                                                <th class="text-right balance">{{ __('balance_after_allocation') }}</th>
                                                <th class="currency">{{ __('currency') }}</th>
                                                <th class="text-right width-fix">{{ __('allocated') }}</th>
                                                <th class="text-right width-fix">{{ __('exchange_rate') }}</th>
                                                <th class="text-right width-fix">{{ __('calculated_amount') }}</th>
                                                <th class="th-before th-last currency">{{ __('currency') }}</th>
                                            </tr>
                                            </thead>
                                            <tbody v-for="(document, index) in modalData.documents">
                                            <tr class="row-one-line indexable">
                                                <td class="td-padding" data-cy="connect-with-document-number"><truncated-text :text="document.document_number" :max_length="20"/>
                                                </td>
                                                <td class="td-padding" data-cy="connect-with-document-date-issued">{{ document.date_issued }}</td>
                                                <td class="td-padding text-right" data-cy="connect-with-document-gross-amount">
                                                    {{ document.document_gross_amount | localizeMoney }}
                                                </td>
                                                <td class="td-padding text-right" data-cy="connect-with-document-balance">
                                                    {{ document.document_balance | localizeMoney }}
                                                </td>
                                                <td>
                                                    <input :value="document.has_left" class="form-control text-right" data-cy="connect-with-document-has-left-input"
                                                           placeholder="0,00" readonly
                                                           type="text">
                                                </td>
                                                <td class="td-padding currency" data-cy="connect-with-document-allocation-currency">
                                                    {{ document.allocation.currency | toUpper }}
                                                </td>
                                                <td>
                                                    <div
                                                        :class="{ 'has-error': hasError('unallocated.documents.' +  index + '.exchanged_amount') }">
                                                        <input v-model="document.allocation.amount"
                                                               :readonly="readonlyAmount(document)"
                                                               class="exchanged-amount form-control text-right"
                                                               data-cy="connect-with-document-allocation-amount"
                                                               placeholder="0,00"
                                                               type="text"
                                                               @change="handleAmountChange('document', index)"
                                                               @keydown="preventNonNumbers($event)">
                                                    </div>
                                                </td>
                                                <td class="exchange-rate-lg">
                                                    <input v-show="showExchangeRate(document)" v-model="document.allocation.exchange_rate"
                                                           :readonly="readonlyExchangeRate(document)"
                                                           class="exchange-rate form-control text-right exchange-rate-lg"
                                                           data-cy="connect-with-document-allocation-exchange-rate"
                                                           placeholder="0,0000"
                                                           type="text"
                                                           @change="handleExchangeRateChange('document', index)"
                                                           @keydown="preventNonNumbers($event)">
                                                </td>
                                                <td>
                                                    <div
                                                        :class="{ 'has-error': hasError('unallocated.documents.' +  index + '.amount') }">
                                                        <input v-show="showExchangedAmount(document)" v-model="document.allocation.exchanged_amount"
                                                               :readonly="readonlyExchangedAmount(document)"
                                                               class="amount form-control text-right"
                                                               data-cy="connect-with-document-allocation-exchange-amount"
                                                               placeholder="0,00"
                                                               type="text"
                                                               @change="handleExchangedAmountChange('document', index)"
                                                               @keydown="preventNonNumbers($event)">
                                                    </div>
                                                </td>
                                                <td class="td-padding" colspan="4">
                                                    <input v-show="showExchangedAmount(document)" v-model="document.allocation.currency" data-cy="connect-with-document-allocation-currency" class="currency form-control"
                                                           readonly
                                                           type="text"
                                                           value="PLN">
                                                </td>
                                            </tr>
                                            <tr v-show="rowHasError(index, 'documents')" class="tr-errors">
                                                <td colspan="6"></td>
                                                <td>
                            <span v-show="hasError('unallocated.documents.' +  index + '.exchanged_amount')"
                                  class="help-block text-danger">
                                {{
                                    hasError('unallocated.documents.' + index + '.amount') ? modalData.errors['unallocated.documents.' + index + '.amount'][0] : ''
                                }}
                            </span>
                                                </td>
                                                <td></td>
                                                <td>
                           <span
                               v-show="hasError('unallocated.documents.' +  index + '.amount') && showExchangedAmount(document)"
                               class="help-block text-danger">
                                {{
                                   hasError('unallocated.documents.' + index + '.amount') ? modalData.errors['unallocated.documents.' + index + '.amount'][0] : ''
                               }}
                           </span>
                                                </td>
                                                <td></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-show="showBottomRow()" class="row">
                                    <div class="col-md-5">
                                        <div v-if="modalOptions.description" data-cy="connect-with-description-div" :class="{ 'has-error': hasError('description') }"
                                             class="padded">
                                            <label class="text-capitalize"><strong>{{
                                                    __('description')
                                                }}</strong></label>
                                            <input :value="modalData.description" class="form-control m-b"
                                                   type="text"
                                                   data-cy="connect-with-description-input"
                                                   @input="setDescription">
                                            <span v-show="hasError('description')" class="help-block text-danger">{{
                                                    hasError('description') ? modalData.errors['description'][0] : ''
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-2 ml-3">
                                        <div :class="{ 'has-error': hasError('settlement_date') }" data-cy="connect-with-settlement-date-div" class="padded">
                                            <label><strong>{{ __('settlement_date') }}</strong></label>
                                            <datepicker :value="modalData.settlement_date"
                                                        @change="setDate"></datepicker>
                                            <span v-show="hasError('settlement_date')" class="help-block text-danger">{{
                                                    hasError('settlement_date') ? modalData.errors['settlement_date'][0] : ''
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-2 ml-2" data-cy="connect-with-description-id-one-div">
                                        <label>{{ __("contractor") }}</label>
                                        <select-2
                                            v-model="connection_contractor_id"
                                            :disabled="contractor_ids.length == 1"
                                            :options="contractor_ids"
                                            :value="connection_contractor_id"
                                            name="contractor_id"
                                        />
                                    </div>
                                    <div class="col-md-2 ml-2" data-cy="connect-with-description-id-two-div">
                                        <label>{{ __("department") }}</label>
                                        <select-2
                                            v-model="connection_department_id"
                                            :disabled="department_ids.length == 1"
                                            :options="department_ids"
                                            :value="connection_department_id"
                                            name="department_id"
                                        />
                                    </div>
                                </div>

                                <div v-if="modalOptions.description && !showBottomRow()" data-cy="connect-with-description" :class="{ 'has-error': hasError('description') }"
                                     class="padded">
                                    <label class="text-capitalize"><strong>{{ __('description') }}</strong></label>
                                    <input :value="modalData.description" class="form-control m-b"
                                           type="text"
                                           data-cy="connect-with-description-input"
                                           @input="setDescription">
                                    <span v-show="hasError('description')" class="help-block text-danger">{{
                                            hasError('description') ? modalData.errors['description'][0] : ''
                                        }}</span>
                                </div>

                                <div v-if="modalOptions.currency_exchange_visible" class="padded">
                                    <label>
                                        <input :checked="modalData.currency_exchange"
                                               :disabled="disabledCurrencyExchange()"
                                               name="currency_exchange"
                                               data-cy="connect-with-settlement-date"
                                               type="checkbox"
                                               @change="setCurrencyExchange">
                                        <strong>&nbsp;{{ __('currency_exchange') }}</strong>
                                    </label>
                                </div>
                                <div v-show="showSettlementDate()" :class="{ 'has-error': hasError('settlement_date') }"
                                    data-cy="connect-settlement-date" class="padded w-15pc pt-3">
                                    <label><strong>{{ __('settlement_date') }}</strong></label>
                                    <datepicker :value="modalData.settlement_date" @change="setDate"></datepicker>
                                    <span v-show="hasError('settlement_date')" class="help-block text-danger">{{
                                            hasError('settlement_date') ? modalData.errors['settlement_date'][0] : ''
                                        }}</span>
                                </div>

                                <div class="modal-footer connect-with-modal-footer">
                                    <button class="btn btn-white" data-cy="connect-with-btn-cancel" type="button" @click="hideModal">{{
                                            __('cancel')
                                        }}
                                    </button>
                                    <button :disabled="submitted" class="btn btn-primary" data-cy="connect-with-btn-save" type="button"
                                            @click="sendModalData">{{ __('save') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import {Money} from '../../services/Money';
import {Decimal} from './../../services/Decimal.js';
import utils from './../../services/Utils.js';
import filters from './../../services/Filters.js';
import events from './../../services/Events.js';
import actions from './../../vuex/action_types.js';
import mutations from './../../vuex/mutation_types.js';
import ModalDocumentLine from "../../components/Payments/ModalDocumentLine";
import ButtonOpenHelpModal from '../../components/help/ButtonOpenHelpModal.vue';

export default {
    name: "modal-connect-with",
    components: {ModalDocumentLine, ButtonOpenHelpModal},
    data: function () {
        return {
            submitted: false,
            money: new Money(),
            modalVisible: false,
            contractor_ids: [],
            connection_contractor_id: null,
            connection_department_id: null,
            department_ids: [],
            allocationMethod: {
                WITH_EX_RATE: 'simple_with_rate',
                NO_EX_RATE: 'simple_without_rate',
            },
        };
    },
    methods: {
        totalAllocated: function () {
            const toAbsFloat = value => {
                return Math.abs(this.money.toFloat(value));
            };

            let unallocated_documents_sum = this.allNotAllocatedDocuments
                .reduce((previousValue, document) => {
                    return parseFloat(previousValue) + toAbsFloat(document.allocation.amount);
                }, 0);

            let unallocated_payments_sum = this.modalData
                .unallocated_payments
                .reduce((previousValue, operation) => {
                    return parseFloat(previousValue) + toAbsFloat(operation.allocation.amount);
                }, 0);
            return unallocated_documents_sum + unallocated_payments_sum;

        },
        updateHasLeft: function () {
            var settledAmount = this.settled.target_amount === "" ? this.settled.balance : this.settled.target_amount;
            this.settled.has_left = this.money.localize(this.money.toFloat(settledAmount) - (this.totalAllocated() * this.getMod(this.settled)));
        },
        updateBalanceAfter: function (item) {
            let allocation = this.parseAllocation(item);
            let has_left = 0;
            if (this.settled.balance === undefined || this.settled.balance === "") {
                this.settled.balance = this.money.toFloat(this.settled.target_amount);
            }
            if (item.balance === undefined || item.balance === "") {
                item.balance = this.money.toFloat(item.target_amount);
            }
            if (this.settlementOperationToOperation()
                || this.settlementOperationToOperations()
                || this.settlementDocumentToDocument()
                || this.settlementDocumentToDocuments()
            ) {
                var balance = (item.balance === undefined ? this.money.toFloat(item.target_amount) : item.balance);
                has_left = Math.abs(balance) - Math.abs(allocation.exchanged_amount);
            } else {
                if ((this.settled.balance < 0 && item.balance > 0) || (this.settled.balance > 0 && item.balance < 0)) {
                    has_left = Math.abs(item.balance) + Math.abs(allocation.exchanged_amount);
                } else {
                    has_left = Math.abs(item.balance) - Math.abs(allocation.exchanged_amount);
                }
            }
            item.has_left = this.money.localize(utils.roundToPrecision(has_left * this.getMod(item)));
        },
        calculateAmountFromExchangedAmount: function (exchanged_amount, item) {
            let allocation = this.parseAllocation(item);
            let amount = (this.settlementDefaultCurrencyToNonDefaultCurrency(item)
                    ? exchanged_amount * allocation.exchange_rate
                    : exchanged_amount / allocation.exchange_rate
            );
            return isFinite(amount) ? Math.abs(amount) : 0;
        },
        calculateExchangedAmountFromAmount: function (amount, item) {
            let allocation = this.parseAllocation(item);
            let exchanged_amount = Math.abs(this.settlementDefaultCurrencyToNonDefaultCurrency(item)
                ? amount / allocation.exchange_rate
                : amount * allocation.exchange_rate,
            );
            return isFinite(exchanged_amount) ? Math.abs(exchanged_amount) : 0;
        },
        handleExchangeRateChange: function (type, index) {
            let item = this.getRowItem(type, index);
            let allocation = this.parseAllocation(item);

            if (this.settlementDifferentNonDefaultCurrencies(item) || this.settlementSameCurrencies(item) || this.settlementWithOutExchangeRates()) {
                return;
            }
            this.updateAllocation('exchange_rate', allocation.exchange_rate, type, index, 4, false, 16);

            if (this.readonlyExchangedAmount(item)) {
                let exchanged_amount = this.calculateExchangedAmountFromAmount(allocation.amount, item);
                this.updateAllocation('exchanged_amount', exchanged_amount, type, index, 4, false, 16);
                this.handleExchangedAmountChange(type, index);
            }
            if (this.readonlyAmount(item)) {
                let amount = this.calculateAmountFromExchangedAmount(allocation.exchanged_amount, item);
                this.updateAllocation('amount', amount, type, index, 4, false, 15);
                this.handleAmountChange(type, index);
            }
            this.updateBalanceAfter(item);
            this.updateHasLeft();
        },
        handleAmountChange: function (type, index) {
            let item = this.getRowItem(type, index);

            let allocation = this.parseAllocation(item);

            if (this.settlementDifferentNonDefaultCurrencies(item)
                || (this.settlementWithOutExchangeRates() && !this.settlementSameCurrencies(item))
            ) {
                if (this.settled.balance === undefined) {
                    this.settled.balance = this.money.toFloat(this.settled.target_amount);
                }
                let amount = this.totalAllocated() >= Math.abs(this.settled.balance) && !this.modalOptions.overpayment_settled
                    ? Math.abs(allocation.amount) - (this.totalAllocated() - Math.abs(this.settled.balance))
                    : allocation.amount;
                this.updateAllocation('amount', amount, type, index);

            } else {
                if (item.balance === undefined) {
                    item.balance = this.money.toFloat(item.target_amount);
                }

                let exchanged_amount = this.calculateExchangedAmountFromAmount(allocation.amount, item);
                exchanged_amount = exchanged_amount > Math.abs(item.balance) && !this.modalOptions.overpayment_unallocated ? Math.abs(item.balance) : exchanged_amount;
                let amount = allocation.exchange_rate != 0 ? this.calculateAmountFromExchangedAmount(exchanged_amount, item) : allocation.amount;

                this.updateAllocation('amount', amount, type, index);
                this.updateAllocation('exchanged_amount', exchanged_amount, type, index);
                if (this.settled.balance === undefined || this.settled.balance === "") {
                    this.settled.balance = this.money.toFloat(this.settled.target_amount);
                }
                if (this.totalAllocated() >= Math.abs(this.settled.balance) && !this.modalOptions.overpayment_settled) {
                    amount = amount - (this.totalAllocated() - Math.abs(this.settled.balance));
                    exchanged_amount = this.calculateExchangedAmountFromAmount(amount, item);

                    this.updateAllocation('amount', amount, type, index);
                    this.updateAllocation('exchanged_amount', exchanged_amount, type, index);
                }
            }
            this.updateBalanceAfter(item);
            this.updateHasLeft();

        },
        handleExchangedAmountChange: function (type, index) {
            let item = this.getRowItem(type, index);
            let allocation = this.parseAllocation(item);
            if (item.balance === undefined) {
                item.balance = this.money.toFloat(item.target_amount);
            }
            if (this.settlementDifferentNonDefaultCurrencies(item)
                || (this.settlementWithOutExchangeRates() && !this.settlementSameCurrencies(item))
            ) {
                let exchanged_amount = Math.abs(allocation.exchanged_amount) > Math.abs(item.balance) && !this.modalOptions.overpayment_unallocated
                    ? item.balance : allocation.exchanged_amount;
                this.updateAllocation('exchanged_amount', exchanged_amount, type, index);

            } else {
                let exchanged_amount = Math.abs(allocation.exchanged_amount) > Math.abs(item.balance) && !this.modalOptions.overpayment_unallocated
                    ? item.balance : allocation.exchanged_amount;
                let amount = this.calculateAmountFromExchangedAmount(exchanged_amount, item);
                this.updateAllocation('amount', amount, type, index);
                this.updateAllocation('exchanged_amount', exchanged_amount, type, index);

                if (this.totalAllocated() >= Math.abs(this.settled.balance) && !this.modalOptions.overpayment_settled) {
                    amount = Math.abs(amount) - (this.totalAllocated() - Math.abs(this.settled.balance));
                    exchanged_amount = this.calculateExchangedAmountFromAmount(amount, item);

                    this.updateAllocation('amount', amount, type, index);
                    this.updateAllocation('exchanged_amount', exchanged_amount, type, index);
                }
            }
            this.updateBalanceAfter(item);
            this.updateHasLeft();

        },
        getMod: function (item) {
            var balance = item.balance === undefined ? this.money.toFloat(item.target_amount) : item.balance;
            if (balance == 0 && item.type_group != undefined) {
                return this.settled.target_amount < 0 ? -1 : 1;
            }
            if (balance == 0 && item.type_group === undefined) {
                return item.amount < 0 ? -1 : 1;
            }
            return balance < 0 ? -1 : 1;
        },
        updateAllocation: function (prop, value, type, index, digits = 2, apply_mod = true, maxDigits = digits) {
            const mod = this.getMod(this.settled);
            const item = this.getRowItem(type, index);
            if (prop == 'exchange_rate') {
                value = typeof value === 'string' ? value.replace(',', '.') : value
                Decimal.set({precision: maxDigits, rounding: 4});
                let decimal = new Decimal(parseFloat(value));

                let modded_value = apply_mod ? decimal.abs().times(mod) : decimal.abs();
                item.allocation[prop] = this.money.localize(modded_value, digits, 16);
                this.$store.commit(mutations.SET_ITEM_ALLOCATION, {
                    type: type,
                    index: index,
                    allocation: item.allocation,
                });
            } else {
                let modded_value = apply_mod ? Math.abs(value) * mod : Math.abs(value);
                item.allocation[prop] = this.money.localize(utils.roundToPrecision(modded_value, digits), digits, maxDigits);
                this.$store.commit(mutations.SET_ITEM_ALLOCATION, {
                    type: type,
                    index: index,
                    allocation: item.allocation,
                });
            }
        },
        getRowItem: function (type, index) {
            return this.$store.getters.getConnectedItem(type, index);
        },
        parseAllocation: function (item) {
            let rate;

            if (typeof item.allocation.exchange_rate === 'string') {
                try {
                    let stringVal = item.allocation.exchange_rate.replace(',', '.');
                    rate = new Decimal(stringVal.replace(/\s/g, ''));
                } catch (e) {
                    rate = new Decimal(0);
                }

            } else {
                rate = new Decimal((item.allocation.exchange_rate));
            }
            return {
                amount: this.money.toFloat(item.allocation.amount) || 0,
                exchanged_amount: this.money.toFloat(item.allocation.exchanged_amount) || 0,
                exchange_rate: this.showExchangeRate(item) ? rate : 1,
            };
        },
        showExchangeRate: function (item) {
            return !this.settlementDifferentNonDefaultCurrencies(item)
                && !this.settlementSameCurrencies(item)
                && !this.settlementWithOutExchangeRates();
        },
        showExchangedAmount: function (item) {
            return this.settlementDifferentNonDefaultCurrencies(item)
                || !this.settlementSameCurrencies(item)
                || (this.settlementWithOutExchangeRates() && !this.settlementSameCurrencies(item));
        },
        showSettlementDate: function () {
            return this.settlementDocumentToDocument() || this.settlementDocumentToDocuments();
        },
        showBottomRow: function () {
            return this.settlementOperationToOperation() || this.settlementOperationToOperations();
        },
        disabledCurrencyExchange: function () {
            if (this.settlementOperationToOperation()) {
                let item = this.getRowItem('operation', 0);
                return this.settlementSameCurrencies(item);
            }
            return true;
        },
        readonlyExchangedAmount: function (item) {
            if (this.settlementSameCurrencies(item)) return true;
            if (this.settlementWithOutExchangeRates()) return false;
            if (this.settlementDocumentToOperations()) {
                if (this.settlementDifferentNonDefaultCurrencies(item)) return false;
                if (this.settlementNonDefaultCurrencyToDefaultCurrency(item)) return false;
                if (this.settlementDefaultCurrencyToNonDefaultCurrency(item)) return false;
            }

            if (this.settlementOperationToDocuments()) {
                if (this.settlementDifferentNonDefaultCurrencies(item)) return false;
                if (this.settlementNonDefaultCurrencyToDefaultCurrency(item)) return true;
                if (this.settlementDefaultCurrencyToNonDefaultCurrency(item)) return true;
            }

            if (this.settlementDocumentToDocument()) {
                if (this.settlementDifferentNonDefaultCurrencies(item)) return false;
                if (this.settlementNonDefaultCurrencyToDefaultCurrency(item)) return false;
                if (this.settlementDefaultCurrencyToNonDefaultCurrency(item)) return true;
            }

            if (this.settlementDocumentToDocuments()) {
                if (this.settlementDifferentNonDefaultCurrencies(item)) return false;
                if (this.settlementNonDefaultCurrencyToDefaultCurrency(item)) return false;
                if (this.settlementDefaultCurrencyToNonDefaultCurrency(item)) return true;
            }

            return !this.settlementDifferentNonDefaultCurrencies(item) && !this.modalOptions.fill_amount;
        },
        readonlyExchangeRate: function (item) {
            if (this.settlementWithOutExchangeRates() || this.settlementSameCurrencies(item)) return true;

            if (this.settlementDocumentToOperations()) {
                if (this.settlementNonDefaultCurrencyToDefaultCurrency(item)) return true;
                if (this.settlementDefaultCurrencyToNonDefaultCurrency(item)) return false;
            }

            if (this.settlementOperationToDocuments()) {
                if (this.settlementNonDefaultCurrencyToDefaultCurrency(item)) return false;
                if (this.settlementDefaultCurrencyToNonDefaultCurrency(item)) return true;
            }

            if (this.settlementDocumentToDocument()) {
                if (this.settlementNonDefaultCurrencyToDefaultCurrency(item)) return true;
                if (this.settlementDefaultCurrencyToNonDefaultCurrency(item)) return true;
            }

            if (this.settlementDocumentToDocuments()) {
                if (this.settlementNonDefaultCurrencyToDefaultCurrency(item)) return true;
                if (this.settlementDefaultCurrencyToNonDefaultCurrency(item)) return true;
            }
            if(this.settlementDocumentToOperations()){
                    if(this.settlementNonDefaultCurrencyToDefaultCurrencyUnallocatedPayment(item)) {
                        return true;
                    }
            }

            return this.modalOptions.fixed_exchange_for_document
                || this.modalOptions.fixed_exchange_from_document;
        },
        readonlyAmount: function (item) {
            if (this.settlementWithOutExchangeRates() || this.settlementSameCurrencies(item)){
                return false;
            }

            if (this.settlementDocumentToOperations()) {
                if (this.settlementDifferentNonDefaultCurrencies(item)) {
                    return false;
                }
                if (this.settlementNonDefaultCurrencyToDefaultCurrency(item)){
                    return true;
                }
                if (this.settlementDefaultCurrencyToNonDefaultCurrency(item)) {
                    return true;
                }

            }

            if (this.settlementOperationToDocuments()) {
                if (this.settlementDifferentNonDefaultCurrencies(item)) return false;
                if (this.settlementNonDefaultCurrencyToDefaultCurrency(item)) return false;
                if (this.settlementDefaultCurrencyToNonDefaultCurrency(item)) return false;
            }

            if (this.settlementDocumentToDocument() || this.settlementDocumentToDocuments()) {
                if (this.settlementDifferentNonDefaultCurrencies(item)) return false;
                if (this.settlementNonDefaultCurrencyToDefaultCurrency(item)) return true;
                if (this.settlementDefaultCurrencyToNonDefaultCurrency(item)) return false;
            }

            return this.modalOptions.fill_amount;
        },
        prepareModalData: function () {
            let locale = document.documentElement.lang;
            let getAllocation = (item) => {
                let allocation = {
                    allocation_id: item.allocation.allocation_id,
                    amount: item.allocation.amount,
                    currency: this.settled.currency,
                    exchange_rate: item.allocation.exchange_rate,
                    exchanged_amount: item.allocation.exchanged_amount,
                    exchange_target_currency: item.allocation.currency,
                    settlement_date: this.modalData.settlement_date,
                    flow_connection: item.flow_connection,
                };

                allocation.amount = this.money.convertToLocale(item.allocation.amount, 2, locale);
                allocation.exchanged_amount = this.money.convertToLocale(item.allocation.exchanged_amount, 2, locale);

                return allocation;
            };
            return {
                settled: {
                    operations: this.modalData.payments_settled.map(getAllocation),
                    documents: this.modalData.documents_settled.map(getAllocation),
                },
                unallocated: {
                    operations: this.modalData.unallocated_payments.map(getAllocation),
                    documents: this.modalData.documents.map(getAllocation),
                    unallocated_documents: this.modalData.unallocated_documents.map(getAllocation),
                },
                description: this.modalData.description,
                currency_exchange: this.modalData.currency_exchange,
                settlement_date: this.modalData.settlement_date,
                contractor_id: this.connection_contractor_id,
                department_id: this.connection_department_id,
                interpretation_type: this.modalOptions.interpretation_type
            };
        },

        sendModalData: function () {
            events.$emit('modalConnectWith:saving');
            this.submitted = true;

            const data = this.prepareModalData();
            if (this.save_method === 'api' || !this.save_method) {
                this.$store.dispatch(actions.MODAL_CONNECT_WITH_SAVE, data)
                    .then(response => {
                        this.$emit('save', {});
                        this.hideModal();
                        this.submitted = false;
                        toastr['success'](response.data.message).css('border', '0px');
                        this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DESCRIPTION, '');
                        this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_CURRENCY_EXCHANGE, false);
                        events.$emit('modalConnectWith:saved');
                    })
                    .catch(error => {
                        this.submitted = false;
                        if (error.response.status === 422) {
                            this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_ERRORS, error.response.data.errors);
                        } else {
                            toastr['error'](this.__('failed_to_perform_action')).css('border', '0px');
                        }
                        events.$emit('modalConnectWith:error');
                    });
            }

            // workaround to plug vue into jquery based views, push data into html input as json
            if (this.save_method === 'html') {
                try {
                    document.getElementById('allocations').value = JSON.stringify(data);
                    toastr['success'](this.__('operation_saved_successfully')).css('border', '0px');
                    this.$emit('save', {});
                    this.hideModal(false);
                    events.$emit('modalConnectWith:saved');
                } catch (error) {
                    toastr['error'](this.__('failed_to_perform_action')).css('border', '0px');
                    events.$emit('modalConnectWith:error');
                } finally {
                    this.submitted = false;
                }
            }
        },
        hasError: function (field) {
            return this.modalData.errors.hasOwnProperty(field)
                && Array.isArray(this.modalData.errors[field])
                && this.modalData.errors[field].length >= 1;

        },
        rowHasError: function (index, type) {
            let validated = ['amount', 'exchanged_amount'];
            for (let i = 0; i < validated.length; i++) {
                if (this.hasError('unallocated.' + type + '.' + index + '.' + validated[i])) {
                    return true;
                }
            }
            return false;
        },
        preventNonNumbers: function ($event) {
            let allowed = [
                'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9', 'Digit0',
                'Comma', 'Minus',
                'Tab', 'Delete', 'Insert', 'ArrowLeft', 'ArrowRight', 'Escape', 'Backspace', 'F5', 'Enter',
                'Numpad0', 'Numpad1', 'Numpad2', 'Numpad3', 'Numpad4', 'Numpad5', 'Numpad6', 'Numpad7', 'Numpad8', 'Numpad9',
                'NumpadComma', 'NumpadDecimal', 'NumpadSubtract', 'NumpadEnter',

            ];
            if (!allowed.includes($event.code)) {
                $event.preventDefault();
            }
        },

        // modal common check-up methods
        settlementDifferentNonDefaultCurrencies: function (row_item) {
            let row_item_is_default = row_item.is_default;
            if (row_item.is_default == undefined) {
                row_item_is_default = row_item.currency_is_default;
            }
            if (this.settled.is_default === undefined) {
                this.settled.is_default = this.settled.currency_is_default;
            }
            return !this.settled.is_default
                && !row_item_is_default
                && (this.settled.currency !== row_item.currency);
        },
        settlementDefaultCurrencyToNonDefaultCurrency: function (item) {
            if (this.settled.is_default === undefined) {
                this.settled.is_default = this.settled.currency_is_default;
            }
            return this.settled.is_default && !item.currency_is_default;
        },
        settlementNonDefaultCurrencyToDefaultCurrency: function (item) {
            return !this.settled.currency_is_default && (item.currency_is_default);
        },
        settlementNonDefaultCurrencyToDefaultCurrencyUnallocatedPayment: function (item){
            return !this.settled.currency_is_default && item.is_default;
        },
        settlementWithOutExchangeRates: function () {
            if (!this.modalOptions.ex_rate_allocation) throw new Error('modal option: exchange rate allocation method is missing');
            return this.modalOptions.ex_rate_allocation === this.allocationMethod.NO_EX_RATE;
        },
        settlementSameCurrencies: function (row_item) {
            return this.settled.currency == row_item.currency;
        },
        settlementOperationToOperation: function () {
            return this.modalData.payments_settled.length === 1
                && this.modalData.unallocated_payments.length === 1
                && this.modalData.documents_settled.length === 0
                && this.allNotAllocatedDocuments.length === 0;
        },
        settlementOperationToOperations: function () {
            return this.modalData.payments_settled.length === 1
                && this.modalData.unallocated_payments.length >= 2
                && this.modalData.documents_settled.length === 0
                && this.allNotAllocatedDocuments.length === 0;
        },
        settlementOperationToDocuments: function () {
            return this.modalData.payments_settled.length === 1
                && this.modalData.unallocated_payments.length === 0
                && this.modalData.documents_settled.length === 0
                && this.allNotAllocatedDocuments.length >= 1;
        },
        settlementOperationToDocument: function () {
            return this.modalData.payments_settled.length === 1
                && this.allNotAllocatedDocuments.length === 1;
        },
        settlementDocumentToOperations: function () {
            return this.modalData.payments_settled.length === 0
                && this.modalData.unallocated_payments.length >= 2
                && this.modalData.documents_settled.length === 1
                && this.allNotAllocatedDocuments.length === 0;
        },
        settlementDocumentToDocument: function () {
            return this.modalData.payments_settled.length === 0
                && this.modalData.unallocated_payments.length === 0
                && this.modalData.documents_settled.length === 1
                && this.allNotAllocatedDocuments.length === 1;
        },
        settlementDocumentToDocuments: function () {
            return this.modalData.payments_settled.length === 0
                && this.modalData.unallocated_payments.length === 0
                && this.modalData.documents_settled.length === 1
                && this.allNotAllocatedDocuments.length >= 1;
        },
        // event handlers
        setExchangeRates: function () {
            const getFXDigits = value => utils.countDecimals(value) > 4 ? utils.countDecimals(value) : 4;
            if (this.settlementWithOutExchangeRates()) {
                this.modalData.unallocated_payments.forEach((payment, index) => {
                    this.updateAllocation('exchange_rate', 1, 'operation', index, 16, false, 4);
                });

                this.modalData.documents.forEach((document, index) => {
                    this.updateAllocation('exchange_rate', 1, 'document', index, 16, false, 4);
                });

                this.modalData.unallocated_documents.forEach((document, index) => {
                    this.updateAllocation('exchange_rate', 1, 'unallocated_document', index, 16, false, 4);
                });
                return;
            }

            if (this.modalOptions.fixed_exchange_from_document) {
                let exchange_rate = this.money.localize(this.settled.exchange_rate, getFXDigits(this.settled.exchange_rate));
                this.modalData.unallocated_payments.forEach(function (payment) {
                    payment.allocation.exchange_rate = exchange_rate;
                });
                this.allNotAllocatedDocuments.forEach(function (document) {
                    document.allocation.exchange_rate = exchange_rate;
                });
            }

            if (this.modalOptions.fixed_exchange_for_document) {
                this.allNotAllocatedDocuments.forEach(document => {
                        document.allocation.exchange_rate = this.money.localize(document.exchange_rate, getFXDigits(document.exchange_rate));

                });
            }

            if (this.settlementDocumentToOperations()) {
                this.modalData.unallocated_payments.forEach(payment => {
                    if (this.settlementNonDefaultCurrencyToDefaultCurrency(payment)) {
                        payment.allocation.exchange_rate = this.money.localize(this.settled.exchange_rate, getFXDigits(this.settled.exchange_rate));
                    }
                });
            }

            if (this.settlementOperationToDocuments()) {
                this.modalData.documents.forEach((document, index) => {
                    if (this.settlementDefaultCurrencyToNonDefaultCurrency(document)) {
                        this.updateAllocation('exchange_rate', document.exchange_rate, 'document', index, getFXDigits(document.exchange_rate), false);
                    }
                });

                this.modalData.unallocated_documents.forEach((document, index) => {
                    if (this.settlementDefaultCurrencyToNonDefaultCurrency(document) && document.exchange_rate != null) {
                        this.updateAllocation('exchange_rate', document.exchange_rate, 'unallocated_document', index, getFXDigits(document.exchange_rate), false);
                    }
                    else if(this.settlementNonDefaultCurrencyToDefaultCurrency(document)){
                        this.updateAllocation('exchange_rate', 0, 'unallocated_document', index, getFXDigits(document.exchange_rate), false)
                    }
                });
            }

            if (this.settlementDocumentToDocument() || this.settlementDocumentToDocuments()) {
                this.modalData.documents.forEach((document, index) => {

                    if (this.settlementDefaultCurrencyToNonDefaultCurrency(document)) {
                        this.updateAllocation('exchange_rate', document.exchange_rate, 'document', index, getFXDigits(document.exchange_rate), false);
                    }

                    if (this.settlementNonDefaultCurrencyToDefaultCurrency(document)) {
                        this.updateAllocation('exchange_rate', this.settled.exchange_rate, 'document', index, getFXDigits(this.settled.exchange_rate), false);
                    }
                });

                this.modalData.unallocated_documents.forEach((document, index) => {
                    if (this.settlementDefaultCurrencyToNonDefaultCurrency(document)) {
                        this.updateAllocation('exchange_rate', document.exchange_rate, 'unallocated_document', index, getFXDigits(document.exchange_rate), false);
                    }

                    if (this.settlementNonDefaultCurrencyToDefaultCurrency(document)) {
                        this.updateAllocation('exchange_rate', this.settled.exchange_rate, 'unallocated_document', index, getFXDigits(this.settled.exchange_rate), false);
                    }
                });
            }
            if(this.settlementDocumentToOperations()){
                this.modalData.unallocated_payments.forEach((unallocated_payment, index) => {
                    if(this.settlementNonDefaultCurrencyToDefaultCurrencyUnallocatedPayment(unallocated_payment)){
                        this.updateAllocation('exchange_rate', this.settled.exchange_rate, 'operation', index, getFXDigits(this.settled.exchange_rate), false)
                    }
                });
            }
        },
        autofill: function () {
            let item, type;
            this.contractor_ids = [];
            if (this.modalData.contractor_ids !== undefined && this.modalData.contractor_ids !== null) {
                if (Object.keys(this.modalData.contractor_ids).length > 0) {
                    for (var key in this.modalData.contractor_ids) {
                        if (this.modalData.contractor_ids.hasOwnProperty(key)) {
                            this.contractor_ids.push({
                                id: key,
                                text: this.modalData.contractor_ids[key],
                            });
                        }
                    }
                    this.connection_contractor_id = this.contractor_ids[0].id;
                }
            }
            this.department_ids = [];
            if (this.modalData.department_ids !== undefined && this.modalData.department_ids !== null) {
                if (Object.keys(this.modalData.department_ids).length > 0) {
                    for (var key in this.modalData.department_ids) {
                        if (this.modalData.department_ids.hasOwnProperty(key)) {
                            this.department_ids.push({
                                id: key,
                                text: this.modalData.department_ids[key],
                            });
                        }
                    }
                    this.connection_department_id = this.department_ids[0].id;
                }
            }
            if (this.modalData.unallocated_payments.length >= 2) {
                for (let step = 0; step < this.modalData.unallocated_payments.length; step++) {
                    this.modalData.unallocated_payments[step].allocation.amount = '0,00';
                }
            }
            if (this.settlementOperationToOperation() && this.settlementDefaultCurrencyToNonDefaultCurrency) {
                this.modalData.unallocated_payments[0].allocation.amount = '0,00';
            }
            if (this.modalData.unallocated_payments.length === 1) {
                item = this.modalData.unallocated_payments[0];
                type = 'operation';
            } else if (this.modalData.documents.length === 0 && this.modalData.unallocated_documents.length === 1) {
                item = this.modalData.unallocated_documents[0];
                type = 'unallocated_document';
            } else if (this.modalData.documents.length === 1 && this.modalData.unallocated_documents.length === 0) {
                item = this.modalData.documents[0];
                type = 'document';
            }
            if (item === undefined || type === undefined) {
                console.log('error: type or item is undefined');
                return;
            }
            if (this.settlementOperationToOperation() && this.settlementSameCurrencies(item)) {
                item.allocation.exchanged_amount = this.money.toFloat(this.settled.has_left);
                this.handleExchangedAmountChange(type, 0);
            }
            if (this.settlementOperationToDocument()
                && ((this.money.toFloat(this.settled.target_amount) > 0 && item.balance > 0) || (this.money.toFloat(this.settled.target_amount) < 0 && item.balance < 0))
                && this.settlementDefaultCurrencyToNonDefaultCurrency(item)
                && !this.settlementWithOutExchangeRates()
            ) {
                let has_left = this.money.toFloat(this.settled.has_left);
                let allocation = this.parseAllocation(item);
                item.allocation.amount = Math.abs(item.balance * allocation.exchange_rate) > Math.abs(has_left) ? has_left : Math.abs(item.balance * allocation.exchange_rate);
                this.handleAmountChange(type, 0);
            }
            if (this.settlementOperationToDocument()
                && ((this.money.toFloat(this.settled.target_amount) > 0 && item.balance > 0) || (this.money.toFloat(this.settled.target_amount) < 0 && item.balance < 0))
                && this.settlementSameCurrencies(item)
            ) {
                let has_left = this.money.toFloat(this.settled.has_left);
                item.allocation.amount = Math.abs(item.balance) > Math.abs(has_left) ? has_left : item.balance;
                this.handleAmountChange(type, 0);
            }

            if (this.settlementDocumentToDocument() && this.settlementSameCurrencies(item)) {
                item.allocation.amount = item.balance;
                this.handleAmountChange(type, 0);
            }

            if (this.settlementDocumentToDocument()
                && (this.settlementNonDefaultCurrencyToDefaultCurrency(item) || this.settlementDefaultCurrencyToNonDefaultCurrency(item))
                && !this.settlementWithOutExchangeRates()
            ) {
                item.allocation.exchanged_amount = item.balance;
                this.handleExchangedAmountChange(type, 0);
            }
            if(this.settlementDocumentToOperations()){
                this.modalData.unallocated_documents.forEach((document, key) => function (){

                })
            }

        },
        destroyLock: function (){
          return window.location.href.indexOf("records/documents")  == -1;
        },
        showModal: function () {

            this.setExchangeRates();
            this.autofill();
            this.modalVisible = true;
        },
        hideModal: function (emit_close = true) {
            let input_data = {
                operations: this.$store.getters.getSelectedOperations,
                documents: this.$store.getters.getSelectedDocuments,
            };
            this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DESCRIPTION, '');
            this.modalVisible = false;
            this.$store.dispatch(actions.DELETE_LOCKS, this.destroyLock() ? input_data : {})
                .then((response) => {
                    if (response.data.success === 'true') {
                        if (emit_close) this.$emit('close', {});
                        events.$emit('modalConnectWith:hide');
                    }

                });

        },
        setDate: function (value) {
            this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DATE, value);
        },
        setDescription: function () {
            this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DESCRIPTION, event.target.value);
        },
        setCurrencyExchange: function () {
            this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_CURRENCY_EXCHANGE, event.target.checked);
        },
        getOperationRootOrSelf: function (operation) {
            return this.$store.getters.getOperationRootOrSelf(operation);
        },
    },
    computed: {
        settled: function () {
            if (this.modalData.payments_settled.length === 1) return this.modalData.payments_settled[0];
            if (this.modalData.documents_settled.length === 1) return this.modalData.documents_settled[0];
        },
        modalData: function () {
            return this.$store.getters.getModalConnectWithData;
        },
        contractorId: function () {
            return this.contractor_ids[0] !== undefined ? this.contractor_ids[0].id : '-1';
        },
        departmentId: function () {
            return this.department_ids[0] !== undefined ? this.department_ids[0].id : '-1';
        },
        modalOptions: function () {
            return this.$store.getters.getModalConnectWithOptions;
        },
        allNotAllocatedDocuments: function () {
            return this.$store.getters.allNotAllocatedDocuments;
        },
        helpName: function () {
            if (this.helpLocalization != null) {
                return this.helpLocalization;
            }
            if (this.isOnePaymentToOneDocument) {
                return 'ZRC-001';
            }
            if (this.isOnePaymentToManyDocuments) {
                return 'ZRD-001';
            }
            if (this.isManyPaymentsToOneDocument) {
                return "ZRI-001";
            }
            if (this.isOneDocumentToOneDocument) {
                return "ZRG-001";
            }
            if (this.isOneDocumentToManyDocuments) {
                return "ZRH-001";
            }
            if (this.isOnePaymentToOnePayment) {
                return "ZRE-001";
            }
            if (this.isOnePaymentToManyPayments) {
                return "ZRF-001";
            }
            return "";
        },
        isOnePaymentToOneDocument: function () {
            return (
                this.modalData.payments_settled.length == 1
                && this.modalData.unallocated_payments.length == 0
                && this.modalData.unallocated_documents.length == 1
                && this.modalData.documents.length == 0
                && this.modalData.documents_settled.length == 0
            );
        },
        isOnePaymentToManyDocuments: function () {
            return (
                this.modalData.payments_settled.length == 1
                && this.modalData.unallocated_payments.length == 0
                && (this.modalData.unallocated_documents.length + this.modalData.documents.length > 1)
                && this.modalData.documents_settled.length == 0
            );
        },
        isManyPaymentsToOneDocument: function () {
            return (
                this.modalData.payments_settled.length == 0
                && this.modalData.unallocated_payments.length > 1
                && this.modalData.unallocated_documents.length == 0
                && this.modalData.documents.length == 0
                && this.modalData.documents_settled.length == 1

            );
        },
        isOneDocumentToOneDocument: function () {
            return (
                this.modalData.payments_settled.length == 0
                && this.modalData.unallocated_payments.length == 0
                && this.modalData.unallocated_documents.length == 1
                && this.modalData.documents.length == 0
                && this.modalData.documents_settled.length == 1
            );
        },
        isOneDocumentToManyDocuments: function () {
            return (
                this.modalData.payments_settled.length == 0
                && this.modalData.unallocated_payments.length == 0
                && (this.modalData.unallocated_documents.length + this.modalData.documents.length > 1)
                && this.modalData.documents_settled.length == 1
            );
        },
        isOnePaymentToOnePayment: function () {
            return (
                this.modalData.payments_settled.length == 1
                && this.modalData.unallocated_payments.length == 1
                && this.modalData.unallocated_documents.length == 0
                && this.modalData.documents.length == 0
                && this.modalData.documents_settled.length == 0
            );
        },
        isOnePaymentToManyPayments: function () {
            return (
                this.modalData.payments_settled.length == 1
                && this.modalData.unallocated_payments.length > 1
                && this.modalData.unallocated_documents.length == 0
                && this.modalData.documents.length == 0
                && this.modalData.documents_settled.length == 0
            );
        },

    },
    mounted: function () {
        events.$on('showConnectWithModal', this.showModal);
        events.$on('hideConnectWithModal', this.hideModal);

    },
    props: {
        'save_method': {
            type: String,
            required: false,
            validator: function (value) {
                return ['api', 'html'].includes(value);
            },
        },
        'target_form_id': {
            type: String,
            required: false,
        },
        'helpLocalization': {
            type: String,
            default: null,
        },
    },
    filters: filters,
};
</script>

<style scoped>
.tr-errors > td {
    border: 0 !important;

}

tbody > tr > td {
    border: 0 !important;
}

.modal-mask {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
    opacity: 0;
}

.exchange-rate-lg {
    width: 140px !important;
}
</style>
